import angular from 'angular';
import 'whatwg-fetch';
import 'core-js/features/url';
import 'core-js/features/url-search-params';
import 'core-js/features/string/replace-all';
import 'font-awesome/css/font-awesome.css';
import 'angular-animate'; // angular-material dependency
import 'angular-aria';
import 'angular-route';
import 'angular-sanitize';
import 'animate.css/animate.min.css'; // Used for page transitions
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'path';
import './css/style.css';
import loadStripe from './js/startup/stripe';
import loadLocationsJS from './js/startup/locations';
import loadIntl from './js/startup/intl';
import loadMomentLocale from './js/startup/momentLocale';
import { loadLocalizedCountries } from './js/lib/localizedCountries';

const loadStartupModules = async (store) => {
  const state = store.getState();
  loadStripe(state);
  loadLocationsJS(state);
  await Promise.all([loadIntl(state), loadMomentLocale(state), loadLocalizedCountries(state)]);
};

export default async ({ store }) => {
  await loadStartupModules(store);

  // This is the angular-i18n file from index.js
  if (typeof localeFile !== 'undefined') {
    localeFile(); // eslint-disable-line
  }

  const PRODUCTION = process.env.NODE_ENV === 'production';

  const requireAll = (requireContext) => requireContext.keys().map(requireContext);

  requireAll(require.context('./js', false, /^\.\/.*\.js$/));
  requireAll(require.context('./js/controllers', true, /^\.\/.*\.js$/));
  requireAll(require.context('./js/directives', true, /^\.\/.*\.js$/));
  requireAll(require.context('./js/services', true, /^\.\/.*\.js$/));
  requireAll(require.context('./js/components', true, /^\.\/.*\.js$/));
  requireAll(require.context('./views', true, /^\.\/.*\.html$/));
  requireAll(require.context('./js/components', true, /^\.\/.*\.html$/));

  const narvarReturnsModule = angular.module('narvarReturns');

  narvarReturnsModule.value('store', store);

  narvarReturnsModule.config([
    '$compileProvider',
    ($compileProvider) => {
      if (PRODUCTION) {
        $compileProvider.debugInfoEnabled(false);
      }
    },
  ]);

  angular.element(document).ready(() => {
    angular.bootstrap(document.body, ['narvarReturns'], {
      strictDI: PRODUCTION,
    });
  });

  try {
    const branding = window.retailerJSON?.branding;
    if (branding) {
      const styleVars = document.createElement('style');
      styleVars.innerHTML = `
        :root {
          ${Object.entries(branding)
            .map(([key, value]) => (value ? `--branding_${key}: ${value};` : null))
            .filter(Boolean)
            .join('\n')}
        }
      `;
      document.head.appendChild(styleVars);
    }
  } catch (e) {
    console.error(e);
  }
};
